import {
  CREATE_MODULE,
  GET_MODULE,
  MODULE_ERROR,
  ROLE_ERROR,
  ROLE_MODULES,
} from "../types";
import moduleService from "reduxStore/service/moduleService";
import strings from "translate/language";
import { errorToast, unAuthorizedError } from "utils/httpClient";

export const getRoleModules = (item) => async (dispatch) => {
  try {
    const res = await moduleService.getRoleModules(item);
    if (res.data.status === 200) {
      dispatch({
        type: ROLE_MODULES,
        payload: res.data,
      });
    } else {
      dispatch({
        type: ROLE_MODULES,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getModuleList = (item) => async (dispatch) => {
  try {
    const res = await moduleService.getModuleList(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_MODULE,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_MODULE,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const createModule = (item) => async (dispatch) => {
  try {
    const res = await moduleService.createModule(item);
    if (res.data.status === 200) {
      dispatch({
        type: CREATE_MODULE,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
